import { create } from 'zustand';
// import { devtools } from 'zustand/middleware';
import { createCommonSlice, CommonSliceType } from '@store/common';

const useStore = create<CommonSliceType>()((...a) => ({
  ...createCommonSlice(...a),
}));

export default useStore;
